import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#2B2B2B] text-[#F8F6F0] py-12 mt-20" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="relative w-10 h-10 flex-shrink-0">
                <svg className="w-full h-full" viewBox="0 0 100 100" fill="none">
                  {/* Circle border */}
                  <circle cx="50" cy="50" r="47" stroke="#D4AF37" strokeWidth="2.5" fill="none"/>
                  
                  {/* Girl silhouette */}
                  {/* Head */}
                  <circle cx="50" cy="22" r="7" fill="#D4AF37"/>
                  
                  {/* Neck and upper body */}
                  <rect x="47" y="29" width="6" height="8" fill="#D4AF37" rx="1"/>
                  
                  {/* Choli/Blouse - fitted top */}
                  <path d="M45 37 L42 45 L42 52 L58 52 L58 45 L55 37 Z" fill="#D4AF37"/>
                  
                  {/* Waist */}
                  <rect x="44" y="52" width="12" height="3" fill="#D4AF37"/>
                  
                  {/* Lehenga - flowing skirt */}
                  <path d="M44 55 Q35 60, 28 75 L28 82 C28 84, 30 85, 32 85 L68 85 C70 85, 72 84, 72 82 L72 75 Q65 60, 56 55 Z" fill="#D4AF37"/>
                  
                  {/* Lehenga pleats/details */}
                  <line x1="38" y1="60" x2="35" y2="78" stroke="#F8F6F0" strokeWidth="1" opacity="0.6"/>
                  <line x1="44" y1="58" x2="42" y2="80" stroke="#F8F6F0" strokeWidth="1" opacity="0.6"/>
                  <line x1="50" y1="57" x2="50" y2="82" stroke="#F8F6F0" strokeWidth="1" opacity="0.6"/>
                  <line x1="56" y1="58" x2="58" y2="80" stroke="#F8F6F0" strokeWidth="1" opacity="0.6"/>
                  <line x1="62" y1="60" x2="65" y2="78" stroke="#F8F6F0" strokeWidth="1" opacity="0.6"/>
                  
                  {/* Dupatta/Scarf flowing */}
                  <path d="M42 40 Q38 45, 36 52" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round" opacity="0.8"/>
                  <path d="M58 40 Q62 45, 64 52" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round" opacity="0.8"/>
                  
                  {/* Arms */}
                  <path d="M42 45 L36 56" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round"/>
                  <path d="M58 45 L64 56" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round"/>
                </svg>
              </div>
              <div className="flex flex-col items-center">
                <h3 className="font-playfair text-2xl text-[#D4AF37] font-bold leading-none">KRYSTAL</h3>
                <span className="font-montserrat text-[10px] text-[#D4AF37] font-light tracking-[0.2em]">APPAREL STORE</span>
              </div>
            </div>
            <p className="font-montserrat text-sm leading-relaxed">
              Traditional Indian fashion with a modern touch. Creating timeless elegance since our inception.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-montserrat text-lg mb-4 text-[#D4AF37]">Quick Links</h4>
            <ul className="space-y-2 font-montserrat text-sm">
              <li><a href="/" className="hover:text-[#D4AF37] transition-colors">Home</a></li>
              <li><a href="/about" className="hover:text-[#D4AF37] transition-colors">About</a></li>
              <li><a href="/courses" className="hover:text-[#D4AF37] transition-colors">Courses</a></li>
              <li><a href="/collection" className="hover:text-[#D4AF37] transition-colors">Collection</a></li>
              <li><a href="/contact" className="hover:text-[#D4AF37] transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-montserrat text-lg mb-4 text-[#D4AF37]">Connect With Us</h4>
            <ul className="space-y-2 font-montserrat text-sm">
              <li>Email: krystalapparelstore@gmail.com</li>
              <li>Phone: +91 6392782674</li>
              <li className="flex space-x-4 mt-4">
                <a href="#" className="hover:text-[#D4AF37] transition-colors">Facebook</a>
                <a href="#" className="hover:text-[#D4AF37] transition-colors">Instagram</a>
                <a href="#" className="hover:text-[#D4AF37] transition-colors">Pinterest</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#D4AF37] mt-8 pt-8 text-center">
          <p className="font-montserrat text-sm">
            © {new Date().getFullYear()} Krystal Apparel Store. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
